// src/pages/Inscription/InscriptionFiche.jsx
import React from "react";
import { FaUserShield } from "react-icons/fa";
import Card from "./Card";

const InscriptionFiche = ({ acteurs, fetchActeurs, loading }) => {
  if (loading) {
    return (
      <div className="py-6 text-center text-sm text-slate-500 dark:text-slate-300">
        Chargement des acteurs...
      </div>
    );
  }

  if (!acteurs || acteurs.length === 0) {
    return (
      <div className="py-6 flex flex-col items-center text-center text-sm text-slate-500 dark:text-slate-300">
        <FaUserShield className="text-2xl mb-2 text-slate-400" />
        <p className="font-semibold">Aucun acteur déclaré pour le moment.</p>
        <p className="text-xs mt-1 max-w-xs">
          Utilisez le formulaire à droite pour ajouter vos premiers acteurs
          (enseignants, dirigeants, arbitres, etc.).
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {acteurs.map((acteur) => (
        <Card key={acteur.id} acteur={acteur} fetchActeurs={fetchActeurs} />
      ))}
    </div>
  );
};

export default InscriptionFiche;
